<section
  class="single-alert single-alert--{{ alertType?.alertType }} single-alert--{{ alertStyle }}"
  [ngClass]="{
    'single-alert--is-modal': isModal,
    'single-alert--has-buttons': hasButtons,
    'single-alert__content-left': alignLeft
  }"
  [ngStyle]="topMargin === false && {'margin-top': 0}">
  <div class="icon__image icon__{{ alertType?.alertType }}-image" role="alert"></div>
  <div>
    <div class="single-alert__heading single-alert__heading--{{ alertType?.alertType }}" [attr.aria-label]="ariaText" *ngIf="heading">
      {{ heading }}
    </div>
    <div class="single-alert__copy">
      <ng-content select="[copy]"></ng-content>
    </div>
    <hr *ngIf="hasButtons" class="divider divider--single-alert-has-buttons">
    <div *ngIf="hasButtons" class="single-alert__buttons single-alert__buttons--{{ alertButtonStyle }}" [ngClass]="{'single-alert__buttons--reverse':reverseButtonOrder}">
      <ng-content select="[buttons]"></ng-content>
    </div>
  </div>
</section>
